import App from '@/App.vue'
import Main from '@/main.js'
// import PluginIE from '@/plugins/ie'
import Router from '@/router'
import Store from '@/store'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

if (process.env.NODE_ENV !== 'development') {
    // if (PluginIE.isIE() || PluginIE.isIE11()) {
        console.log = function() {}
        console.warn = function() {}
        console.error = function() {}
    // }
    // else {
    //     console.log = function(...args) {}
    //     console.warn = function(...args) {}
    //     console.error = function(...args) {}
    // }
}

Vue.config.productionTip = false

const router = Router.create(Main.router.routes)

Vue.use(VueAnalytics, {
    id: 'UA-128189536-1',
    disabled: true,
    router,
    autoTracking: {
        pageviewTemplate (route) {
            return {
                page: route.path,
                title: route.meta.title ? route.meta.title : '',
                location: window.location.href
            }
        }
    }
})

Object.keys(Main.components).forEach(tag => {
    Vue.component(tag, Main.components[tag])
})

Main.plugins.forEach(plugin => {
    Vue.use(plugin)
})

new Vue({
    router,
    store: Store,
    render: h => h(App),
}).$mount('#root')
